import { Directive, InjectionToken } from '@angular/core';

export const KT_PORTLET_ICON = new InjectionToken<KtPortletIcon>('KtPortletIcon');

@Directive({
	selector: 'ktPortletIcon,[ktPortletIcon]',
	providers: [{ provide: KT_PORTLET_ICON, useExisting: KtPortletIcon }],
})
export class KtPortletIcon {}
